export default "__VITE_ASSET__x3h0rmPZ__"